import React from "react";
import { formatVendorReturnStatusLabel } from "../../utils/vendorShopOrders";

function formatWhen(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function InfoBlock({ title, children }) {
  return (
    <div className="min-w-0">
      <p className="mb-2 text-[13px] font-Montserratsemibold text-[#F4802C]">
        {title}
      </p>
      <div className="border border-[#E1E8D5] bg-white px-4 py-3 text-[13px] font-Montserratmedium text-[#2B2B2B]">
        {children}
      </div>
    </div>
  );
}

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div className="border-b border-[#E1E8D5] py-2 last:border-0">
      <p className="text-[11px] uppercase tracking-wide text-[#888]">{label}</p>
      <p className="mt-0.5 font-Montserratsemibold">{value}</p>
    </div>
  );
}

const ShopReturnDetailSection = ({ returnRequest, returnStatusLabel }) => {
  if (!returnRequest) return null;

  const statusText =
    returnStatusLabel ||
    formatVendorReturnStatusLabel(returnRequest.status);
  const isRejected =
    returnRequest.status === "rejected" ||
    returnRequest.status === "return_rejected";
  const images = returnRequest.evidenceImages || [];
  const videos = returnRequest.evidenceVideos || [];

  return (
    <div className="mb-8 border border-[#F4802C]/35 bg-[#FFF8F3]">
      <div className="border-b border-[#F4802C]/25 px-5 py-3 md:px-6">
        <h3 className="font-BonaNovabold text-[17px] text-[#F4802C] md:text-[18px]">
          Return details
        </h3>
        <p className="mt-0.5 text-[12px] font-Montserratmedium text-[#555]">
          Status:{" "}
          <span className="font-Montserratsemibold text-[#2B2B2B]">
            {statusText}
          </span>
          {returnRequest.resolvedAt ? (
            <span className="text-[#777]">
              {" "}
              · Updated {formatWhen(returnRequest.resolvedAt)}
            </span>
          ) : returnRequest.requestedAt ? (
            <span className="text-[#777]">
              {" "}
              · Requested {formatWhen(returnRequest.requestedAt)}
            </span>
          ) : null}
        </p>
      </div>

      <div className="grid gap-4 px-5 py-4 md:grid-cols-2 md:px-6 md:py-5">
        <InfoBlock title="Customer return request">
          <Row label="Reason" value={returnRequest.reason} />
          <Row label="Customer note" value={returnRequest.customerNote} />
          {!returnRequest.reason && !returnRequest.customerNote ? (
            <p className="py-1 text-[#888]">—</p>
          ) : null}
        </InfoBlock>

        <InfoBlock
          title={isRejected ? "Your rejection response" : "Seller / vendor note"}
        >
          <Row
            label={isRejected ? "Rejection reason" : "Note"}
            value={returnRequest.vendorNote}
          />
          {!returnRequest.vendorNote ? (
            <p className="py-1 text-[#888]">—</p>
          ) : null}
        </InfoBlock>
      </div>

      {images.length > 0 || videos.length > 0 ? (
        <div className="border-t border-[#F4802C]/20 px-5 pb-5 md:px-6">
          <p className="mb-3 pt-4 text-[13px] font-Montserratsemibold text-[#F4802C]">
            Customer evidence
          </p>
          <div className="flex flex-wrap gap-2">
            {images.map((item) => (
              <a
                key={item.url}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block h-20 w-20 overflow-hidden border border-[#E1E8D5] bg-white"
              >
                <img
                  src={item.url}
                  alt=""
                  className="h-full w-full object-cover"
                />
              </a>
            ))}
            {videos.map((item) => (
              <a
                key={item.url}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-20 w-20 items-center justify-center border border-[#E1E8D5] bg-white text-[10px] font-Montserratsemibold text-[#555]"
              >
                Video
              </a>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ShopReturnDetailSection;
